import { FC } from 'react';
import { AccordionContentProps } from '../../Accordion.types';
import { getClasses } from '@/_utils/classnames';
import styles from './AccordionContent.module.css';

export const AccordionContent: FC<AccordionContentProps> = ({
  children,
  isOpen,
}) => (
  <div className={getClasses(styles.content, { [styles.contentOpen]: isOpen })}>
    {children}
  </div>
);
